import { render, staticRenderFns } from "./view-homework.vue?vue&type=template&id=0ae292ac&"
import script from "./view-homework.vue?vue&type=script&lang=js&"
export * from "./view-homework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports